export const ROOT = "/";

export const MOD_ADMIN = "/admin";

export const LIVE_DRAW = "/liveDraw";

export const TRACKCO = "/trackco"

